import axios, { AxiosInstance } from 'axios'
import { useRef } from 'react'
import { useAppDispatch } from '../../presentation/hooks/store-hooks'
import { useLocalStorageService } from '../../use-cases/local-storage'
import { setTokenState } from '../../application/states/auth'

export const useAxiosInstances = () => {
  const dispatch = useAppDispatch()
  const { getItem, removeItem } = useLocalStorageService()

  // Refs para manter instâncias estáveis — NÃO recria quando token muda
  const axiosInstanceRef = useRef<AxiosInstance | null>(null)
  const axiosAuthInstanceRef = useRef<AxiosInstance | null>(null)

  if (!axiosInstanceRef.current) {
    axiosInstanceRef.current = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL
    })
  }

  if (!axiosAuthInstanceRef.current) {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      timeout: Number(process.env.AXIOS_TIMEOUT ?? 0)
    })

    // Interceptor de request: lê token do localStorage dinamicamente (sem dep no state)
    instance.interceptors.request.use((config) => {
      const token = getItem({ key: 'ACCESS_TOKEN' })
      if (token && token !== 'not_valid') {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    }, (error) => Promise.reject(error))

    // Interceptor de response: trata 401 (expirado ou IP bloqueado)
    instance.interceptors.response.use((response) => response, (error) => {
      if (error?.response?.status === 401) {
        const resData = error.response?.data || {}
        const msg = resData.message || resData.error || resData.Mensagem || resData.mensagem || ""
        const isIpBlock = Boolean(msg && typeof msg === 'string' && msg.toLowerCase().includes("ip"))

        if (!isIpBlock) {
          const token = getItem({ key: 'ACCESS_TOKEN' })
          if (token) {
            dispatch(setTokenState(''))
            removeItem({ key: 'ACCESS_TOKEN' })
          }
          window.localStorage.clear()
          window.sessionStorage.clear()

          let loginUrl = String(process.env.REACT_APP_VELES_LOGIN_BASE_URL)
          if (!loginUrl.includes('/authentication/login')) {
            loginUrl = loginUrl.replace('/auth/login', '/authentication/login')
          }

          if (window.location.pathname !== '/auth/login') {
            window.location.href = `${loginUrl}?logout=true`
          }
        }
      }
      return Promise.reject(error)
    })

    axiosAuthInstanceRef.current = instance
  }

  return {
    axiosInstance: axiosInstanceRef.current,
    axiosAuthInstance: axiosAuthInstanceRef.current
  }
}